
import moment from 'moment';

export const getItem = (key) => {
    return localStorage.getItem(key);
}

export const setItem = (key, value) => {
    return localStorage.setItem(key, value);
}

export const removeItem = (key) => {
    return localStorage.removeItem(key);
}

const checkTokenExparation = (time) => {
    const tokenExpirationTimeInSeconds = (moment(time).valueOf() - moment().valueOf()) / 1000;

    if (time && tokenExpirationTimeInSeconds > 10) {
        return true;
    }

    return false;
}

export const isValidToken = (baseTokenTime, loginTokenTime) => {

    if(loginTokenTime && checkTokenExparation(loginTokenTime)) {
        return true;
    } else if (baseTokenTime && checkTokenExparation(baseTokenTime)) {
        return true;
    }

    return false;
}

export const isValidLoginToken = (loginToken) => {
    if(loginToken?.expires_at && checkTokenExparation(loginToken?.expires_at)) return true;

    return false;
}
